module.exports = __webpack_public_path__ + "img/ys2.00f26d10.png";